package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.pathParamFollowing
import com.fsryan.foundation.net.client.replacePathParams

/**
 * `DELETE /api/v1/uploads/{uploadId}`: deletes a failed job-description upload, its stored file and its OpenAI file.
 * 204 when done; 404 for another user's upload; 409 when it did not fail.
 */
class WMDeleteUploadRequestBuilder: FSAuthenticatedRequestBuilder<WMDeleteUploadRequestBuilder, Nothing>() {

    private var uploadId: String? = null

    fun uploadId(uploadId: String): WMDeleteUploadRequestBuilder {
        this.uploadId = uploadId
        return this
    }

    override fun applyFrom(request: FSRequest<Nothing>): WMDeleteUploadRequestBuilder {
        uploadId = request.pathParamFollowing("uploads")
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Delete)
        val id = uploadId ?: error("An upload id must be provided")
        replacePathParams("api", "v1", "uploads", id)
        return super.build()
    }

    override fun clear(): WMDeleteUploadRequestBuilder {
        uploadId = null
        return super.clear()
    }

    override fun self(): WMDeleteUploadRequestBuilder = this
}
